import React from 'react'
import { FileAnswerModel } from '../../../../model/knowledge.model'
import './FileAnswer.css'
import { FileTypeIcon } from '../../../../conf/images'
import ReuploadButton from './ReuploadButton'

interface FileAnswerProps {
    answer: string
    onReupload?: (answer: string) => void
    isLocked?: boolean
}
const FileAnswer = (props: FileAnswerProps) => {
    let fileObj: FileAnswerModel = {
        SourceUrl: '',
        FileName: '',
    }
    try {
        fileObj = JSON.parse(props.answer) as FileAnswerModel
    } catch (error) {}
    return (
        <div className='file-answer-item'>
            <div className='file-answer-icon'>
                <img src={FileTypeIcon} alt='file' />
            </div>
            <p className='file-name single-ell'>{fileObj.FileName}</p>
            {!props.isLocked && (
                <ReuploadButton
                    acceptType='file'
                    lt={50}
                    onResolve={(src, name) => {
                        const imageAnswer: FileAnswerModel = {
                            FileName: name,
                            SourceUrl: src,
                        }
                        props.onReupload &&
                            props.onReupload(JSON.stringify(imageAnswer))
                    }}
                />
            )}
        </div>
    )
}
export default FileAnswer
